import cookies from "js-cookie";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useIsAuth } from "@hooks/useIsAuth";
import { ACCESS_TOKEN } from "@constants/common";
import { login, register, root } from "@constants/navlinks";

export const useAuthCheck = () => {
  const token = cookies.get(ACCESS_TOKEN);
  const isAuth = useIsAuth();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const paths =
    pathname === root ||
    pathname === `/${login}` ||
    pathname === `/${register}`;

  useEffect(() => {
    if (!token && !isAuth && pathname !== `/${register}`) navigate(login);
    if (paths && isAuth) navigate(root);
  }, [pathname, isAuth]);
};
